var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"id":"app2","data-title":"零碳在线H5"}},[_c('div',{staticClass:"subapp_container"},[_c('div',{staticClass:"contain",staticStyle:{}},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }